/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IdtypeToadd as AgentApiContractIdtypeToadd } from '../../models/AgentApi/Contract/idtype-toadd';

export interface ApiAgentListIdtypeToaddGet$Params {

/**
 * Interface language
 */
  lang?: string;
}

export function apiAgentListIdtypeToaddGet(http: HttpClient, rootUrl: string, params?: ApiAgentListIdtypeToaddGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractIdtypeToadd>>> {
  const rb = new RequestBuilder(rootUrl, apiAgentListIdtypeToaddGet.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AgentApiContractIdtypeToadd>>;
    })
  );
}

apiAgentListIdtypeToaddGet.PATH = '/api/Agent/ListIdtypeToadd';
